module.exports = __webpack_public_path__ + "img/LogoTrackInvertido.5330b201.png";